import { SearchInput } from "../../filters/ui/SearchInput";

import { useNewsAlertsFilterStore } from "./useNewsAlertsFilterStore";

export const Search = () => {
    const searchValue = useNewsAlertsFilterStore((state) => state.searchValue);
    const setSearchValue = useNewsAlertsFilterStore((state) => state.setSearchValue);

    return (
        <SearchInput
            value={searchValue}
            onChange={setSearchValue}
        />
    );
};
